// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__uPjvA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2ZLzV"};